/* global Autodesk, THREE */ // eslint-disable-line

import { updateMarkupState } from "../../helpers/actions/Action";
import store from "../../helpers/store/Store";
import { connect } from "react-redux";
import $ from 'jquery';


class MarkupToolbarExtension extends Autodesk.Viewing.Extension {
  constructor(viewer, options) {
    super(viewer, options);
    this._toolbar = null;
    this._group = null;
    this._groupTwo = null;
    this._groupThree = null;
    this._saveButton = null;

    // this.state = {
    //   showMarkup: false,
    //   showData: false,
    //   showReports: false,
    //   showCalculations: false,
    //   showMetaProperties: false,
    //   showViewer: false,
    //   showStartText: true,
    //   currentShown: false,
    //   isMobile: false,
    //   isTablet: false,
    //   size: null,
    // };
  }

  load() {
    console.log("MarkupToolbarExtension loaded");
    return true;
  }

  unload() {
    console.log("MarkupToolbarExtension unloaded");
    this._toolbar.setVisible(false);
    return true;
  }

  onToolbarCreated() {
    this._toolbar = new Autodesk.Viewing.UI.ToolBar("MarkupToolbar", {
      alignVertically: true,
    });
    if (false /* align to the left */) {
      const { style } = this._toolbar.container;
      style.left = "15px";
      style.right = "unset";
    }
    this._group = new Autodesk.Viewing.UI.ControlGroup("markupGroup");
    this._groupTwo = new Autodesk.Viewing.UI.ControlGroup("markupGroup2");
    this._groupThree = new Autodesk.Viewing.UI.ControlGroup("markupGroup3");

    // buttons
    this._openButton = new Autodesk.Viewing.UI.Button("openButton");
    this._openButton.setIcon("icon-markups-open");
    this._openButton.setToolTip("Load markups");
    this._openButton.onClick = (ev) => {
      store.dispatch(updateMarkupState("open"));
      this._createToggler(this._openButton, this._load, this._unload);
    };

    this._textButton = new Autodesk.Viewing.UI.Button("textButton");
    this._textButton.setIcon("icon-markups-text");
    this._textButton.setToolTip("Text");
    this._textButton.onClick = function (ev) {
      store.dispatch(updateMarkupState("text"));
    };

    this._rectButton = new Autodesk.Viewing.UI.Button("rectButton");
    this._rectButton.setIcon("icon-markups-rectangle");
    this._rectButton.setToolTip("Rectangle");
    this._rectButton.onClick = function (ev) {
      store.dispatch(updateMarkupState("rect"));
    };

    this._circButton = new Autodesk.Viewing.UI.Button("circButton");
    this._circButton.setIcon("icon-markups-circle");
    this._circButton.setToolTip("Circle");
    this._circButton.onClick = function (ev) {
      store.dispatch(updateMarkupState("circ"));
    };

    this._polyButton = new Autodesk.Viewing.UI.Button("polyButton");
    this._polyButton.setIcon("icon-markups-poly");
    this._polyButton.setToolTip("Polyline");
    this._polyButton.onClick = function (ev) {
      store.dispatch(updateMarkupState("poly"));
    };

    this._freeButton = new Autodesk.Viewing.UI.Button("freeButton");
    this._freeButton.setIcon("icon-markups-free");
    this._freeButton.setToolTip("Freehand");
    this._freeButton.onClick = function (ev) {
      store.dispatch(updateMarkupState("free"));
    };

    this._cloudButton = new Autodesk.Viewing.UI.Button("cloudButton");
    this._cloudButton.setIcon("icon-markups-cloud");
    this._cloudButton.setToolTip("Cloud");
    this._cloudButton.onClick = function (ev) {
      store.dispatch(updateMarkupState("cloud"));
    };

    this._arrowButton = new Autodesk.Viewing.UI.Button("arrowButton");
    this._arrowButton.setIcon("icon-markups-arrow");
    this._arrowButton.setToolTip("Arrow");
    this._arrowButton.onClick = function (ev) {
      store.dispatch(updateMarkupState("arrow"));
    };

    this._exitButton = new Autodesk.Viewing.UI.Button("exitButton");
    this._exitButton.setIcon("icon-markups-exit");
    this._exitButton.setToolTip("Exit markup");
    this._exitButton.onClick = function (ev) {
      store.dispatch(updateMarkupState("exit"));
    };

    this._saveButton = new Autodesk.Viewing.UI.Button("saveButton");
    this._saveButton.setIcon("icon-markups-save");
    this._saveButton.setToolTip("Save markup");
    this._saveButton.onClick = function (ev) {
      // store.dispatch(updateMarkupState("save"));
      $('#createModal').modal('show')
    };

    // Add buttons
    this._group.addControl(this._openButton);
    this._groupTwo.addControl(this._textButton);
    this._groupTwo.addControl(this._rectButton);
    this._groupTwo.addControl(this._circButton);
    this._groupTwo.addControl(this._polyButton);
    this._groupTwo.addControl(this._freeButton);
    this._groupTwo.addControl(this._cloudButton);
    this._groupTwo.addControl(this._arrowButton);
    this._groupThree.addControl(this._exitButton);
    this._groupThree.addControl(this._saveButton);
    this._toolbar.addControl(this._group);
    this._toolbar.addControl(this._groupTwo);
    this._toolbar.addControl(this._groupThree);
    this.viewer.container.appendChild(this._toolbar.container);
  }

  _createToggler = function (openButton, load, unload) {
    var state = openButton.getState();

    if (state === Autodesk.Viewing.UI.Button.State.INACTIVE) {
      openButton.setState(Autodesk.Viewing.UI.Button.State.ACTIVE);

      load();
    } else if (state === Autodesk.Viewing.UI.Button.State.ACTIVE) {
      openButton.setState(Autodesk.Viewing.UI.Button.State.INACTIVE);
      unload();
    }
  };

  _load = function () {
    const pane1 = document.querySelector(".Pane1");
    pane1.style.width = (window.innerWidth - 340) * 0.6 + "px";
  };

  _unload = function () {
    const pane1 = document.querySelector(".Pane1");
    pane1.style.width = window.innerWidth - 340 + "px";
  };
}

const mapStateToProps = (state) => ({
  markupState: state.markupStateReducer.markupState,
});

export default connect(mapStateToProps)(MarkupToolbarExtension);

Autodesk.Viewing.theExtensionManager.registerExtension(
  "MarkupToolbarExtension",
  MarkupToolbarExtension
);
